var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.54 133.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-net,.cls-2-net{fill:none;stroke-miterlimit:10;stroke-width:2px;}.cls-1-net{stroke:#ff3b83;}.cls-2-net{stroke:#ffc300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Resume_new",
    "data-name": "Icone Resume new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-net",
    cx: 54.6,
    cy: 55.59,
    r: 14.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-net",
    d: "M85.68.87A62.93,62.93,0,0,1,54.61,118.52"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-net",
    cx: 54.6,
    cy: 55.59,
    r: 53.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-net",
    d: "M34.85,85A35.46,35.46,0,0,1,19.14,55.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-net",
    d: "M54.6,100.12A44.59,44.59,0,0,1,10.06,55.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-net",
    d: "M54.6,11.05A44.59,44.59,0,0,1,99.14,55.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-net",
    d: "M69.21,128.45v4.18H40v-4.18h7.89a4.62,4.62,0,0,0,4.62-4.62v-5.32h4.66v5.32a4.62,4.62,0,0,0,4.62,4.62Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-net",
    x1: 101.86,
    y1: 14.19,
    x2: 80.84,
    y2: 32.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-net",
    x: 72.68,
    y: 33.06,
    width: 8.96,
    height: 5.13,
    transform: "translate(-4.52 59.11) rotate(-40.82)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1-net",
    x1: 55.95,
    y1: 46.03,
    x2: 55.95,
    y2: 61.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-net",
    cx: 53.57,
    cy: 61.84,
    r: 2.38
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNetwork);
export default __webpack_public_path__ + "static/media/home-network.9615ee6884fa2fdd157645ccd786d036.svg";
export { ForwardRef as ReactComponent };